import React from "react";
import { Outlet } from "react-router-dom";
import Footnote from "./Footnote";
import Header from "./Header";

const Layout = ({ footnote = "" }) => {
  return (
    <>
      <Header />
      <div className="container py-3">
        <Outlet></Outlet>
        <Footnote footnote={footnote} />
      </div>
    </>
  );
};

export default Layout;
